(function($, root) {
  "use strict";

  $.startTimer = function() {
    if (!window.rdo.timer.started) {
      //start timer if it ise not started!

      window.rdo.timer.started = true;

      window.rdo.timer.timer = $.timer(function() {
        // console.log('timer - end');

        //after timer ends:
        //move to next time interval:
        if (window.rdo.preloading == 'next' && window.rdo.preloadCompleted) {

          // console.log('preload complete so moving on');
          $.moveNextContent();
        } else if (window.rdo.preloading == 'next') {
          // console.log('should wiat until preload');
          $.waitUntilPreload();
        }

      });

      // console.log('timer started');

      //init timer:
      window.rdo.timer.timer.set({
        time: window.rdo.transitions.content,
        autostart: true
      });

      $.updateTimerButton();

    }
    //
    // else {
    //   console.log('timer - not starting, already started!');
    // }

  };

  $.pauseTimer = function(hardpause) {
    hardpause = hardpause || undefined;
    console.log('timer should pause');
    if (hardpause !== undefined) {
      window.rdo.timer.hardpause = hardpause;
    }

    if (window.rdo.timer.hardpause) {
      console.log('hard pause!');
    }

    if (window.rdo.timer.timer) {
      window.rdo.timer.paused = true;
      $('#paused-icon').css('display', 'flex');
      $('timer fill').addClass('paused');
      $('#full-page-background .overlay').addClass('paused');
      window.rdo.timer.timer.pause();
      console.log('timer paused');
      $.updateTimerButton();

    }

  };

  $.continueTimer = function(hardcontinue) {
    hardcontinue = hardcontinue || false;

    if (window.rdo.timer.hardpause) {
      console.log('timer should not continue due to hard pause!!');

    }
    //
    if (hardcontinue) {
      console.log('hard continue!!');

    }

    if (!window.rdo.timer.hardpause || hardcontinue) {
      console.log('timer should continue');
      if (window.rdo.timer.timer) {
        window.rdo.timer.paused = false;
        $('#paused-icon').css('display', 'none');
        $('timer fill').removeClass('paused');
        $('#full-page-background .overlay').removeClass('paused');
        window.rdo.timer.timer.play();
        console.log('timer is continueing');
        $.updateTimerButton();

      }
    }

  };

  $.resetTimer = function() {

    $.resetTimerAnimations();
    window.rdo.timer.started = false;

    if (window.rdo.timer.timer) {
      window.rdo.timer.timer.clearTimer();
      $.updateTimerButton();
    }

  };

  $.updateTimerButton = function() {
    let selected = $('.timer-button').find('.selected');
      selected.removeClass('selected');
    if (window.rdo.timer.paused) {

      $('.timer-button').find('.play').addClass('selected');

    } else {
      // selected.removeClass('selected');
      $('.timer-button').find('.pause').addClass('selected');

    }

    // if (selected.hasClass('play')) {
    //   selected.removeClass('selected');
    //   $('.timer-button').find('.pause').addClass('selected');
    //
    // } else {
    //   selected.removeClass('selected');
    //   $('.timer-button').find('.play').addClass('selected');
    // }

  }
  $('html').on('click', '.timer-button', function() {
    let selected = $(this).find('.selected');
    if (window.rdo.timer.paused) {
      // selected.removeClass('selected');
      // $(this).find('.pause').addClass('selected');

      $.continueTimer();
      $.playAudio();

    } else {
      // selected.removeClass('selected');
      // $(this).find('.play').addClass('selected');
      $.pauseTimer();
      $.pauseAudio();
    }

  });

  $('.reset-time').on('click touchstart', function() {
    $.resetTimer();
    $.startTimer();
    $.startTimerAnimations();
  });


  $('body').keyup(function(e) {
    if (e.keyCode == 32) {
      // user has pressed space
      if (window.rdo.timer.paused) {
        $.continueTimer();
        $.playAudio();

      } else {
        $.pauseTimer();
        $.pauseAudio();
      }
    }
  });

})(jQuery, this);

// animation-play-state: paused;
